import { DELIVERY_ORDER_SUCCESS } from "../constants";

const initialState = {
  list: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
  case DELIVERY_ORDER_SUCCESS:
    return {
      ...state,
      list: action.payload
    };
  default:
    return state;
  }
}